import {
  GET_MEETING_DETAILS_INIT,
  GET_MEETING_DETAILS_SUCCESS,
  GET_MEETING_DETAILS_FAILED,
  DELETE_MEETING_INIT,
  DELETE_MEETING_SUCCESS,
  DELETE_MEETING_FAILED,
  UPDATE_GOOGLE_CALENDAR_MEETING_INIT,
  UPDATE_GOOGLE_CALENDAR_MEETING_SUCCESS,
  UPDATE_GOOGLE_CALENDAR_MEETING_FAILED,
  UPDATE_OUTLOOK_CALENDAR_MEETING_INIT,
  UPDATE_OUTLOOK_CALENDAR_MEETING_SUCCESS,
  UPDATE_OUTLOOK_CALENDAR_MEETING_FAILED,
  GET_MONTHLY_MEETING_INIT,
  GET_MONTHLY_MEETING_SUCCESS,
  GET_MONTHLY_MEETING_FAILED,
} from "./constants";
export const initialState = {
  loading: false,
  meetingData:[],
  getMeeting: {},
};

export default function meetingDetails(state = initialState, action) {
  switch (action.type) {
    case GET_MONTHLY_MEETING_INIT:
      return { ...state, loading: true };
    case GET_MONTHLY_MEETING_SUCCESS:
      console.log('action payload ', action.payload);
      return { ...state, loading: false, meetingData: action.payload };
    case GET_MONTHLY_MEETING_FAILED:
      return { ...state, loading: false };
    case GET_MEETING_DETAILS_INIT:
      return { ...state, loading: true };
    case GET_MEETING_DETAILS_SUCCESS:
      return { ...state, loading: false, getMeeting: action.payload };
    case GET_MEETING_DETAILS_FAILED:
      return { ...state, loading: false };
    case DELETE_MEETING_INIT:
      return { ...state, loading: true };
    case DELETE_MEETING_SUCCESS:
      return { ...state, loading: false };
    case DELETE_MEETING_FAILED:
      return { ...state, loading: false };
    case UPDATE_GOOGLE_CALENDAR_MEETING_INIT:
      return { ...state, loading: true };
    case UPDATE_GOOGLE_CALENDAR_MEETING_SUCCESS:
      return { ...state, loading: false };
    case UPDATE_GOOGLE_CALENDAR_MEETING_FAILED:
      return { ...state, loading: false };
    case UPDATE_OUTLOOK_CALENDAR_MEETING_INIT:
      return { ...state, loading: true };
    case UPDATE_OUTLOOK_CALENDAR_MEETING_SUCCESS:
      return { ...state, loading: false };
    case UPDATE_OUTLOOK_CALENDAR_MEETING_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
